import {
    GET_USER_ASSIGNED_APPLICATIONS,
    GET_USER_ASSIGNED_APPLICATIONS_FULFILLED,
    GET_USER_ASSIGNED_APPLICATIONS_REJECTED,

    GET_COMPLETE_USER_DETAILS,
    GET_COMPLETE_USER_DETAILS_FULFILLED,
    GET_COMPLETE_USER_DETAILS_REJECTED
} from '../constants/Action'

import {getUserSearchResourceGRPCClient, getTenantId} from './constants';
import {GetCompleteUserDetailsRequest} from '../proto/starlord/messages/request/get_complete_user_details_request_pb'
import {UserAssignedApplicationsRequest} from '../proto/starlord/messages/request/user_assigned_applications_request_pb'

const UserService = getUserSearchResourceGRPCClient();

export function GetUserAssignedApplications(id){
    var request = new UserAssignedApplicationsRequest()
    request.setTenantid(getTenantId())
    request.setUserid(id)

    return dispatch => {
        dispatch({type: GET_USER_ASSIGNED_APPLICATIONS})
        UserService.getUserAssignedApplications(request, {'x-txn-id': sessionStorage.getItem("xTxnId")}, (err, response) => {
            if(err){
                dispatch({type: GET_USER_ASSIGNED_APPLICATIONS_REJECTED, payload: err})
            }
            else{
                dispatch({type: GET_USER_ASSIGNED_APPLICATIONS_FULFILLED, payload: response.toObject()})
            }
        })
    }
}

export function GetCompleteUserDetails(userId){
    var request = new GetCompleteUserDetailsRequest()
    request.setUserid(userId)
    return dispatch => {
        dispatch({type: GET_COMPLETE_USER_DETAILS})
        UserService.getCompleteUserDetails(request, {'x-txn-id': sessionStorage.getItem("xTxnId")}, (err, response) => {
            if(err){
                dispatch({type: GET_COMPLETE_USER_DETAILS_REJECTED, payload: err})
            }
            else{
                dispatch({type: GET_COMPLETE_USER_DETAILS_FULFILLED, payload: response.toObject()})
            }
        })
    }
}